<template>
  <v-content class="forgotten-password page">
    <v-container>
      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card v-if="token" raised class="mt-3">
            <v-toolbar card :color="themes.candidate.light.dialogTitle">
              <v-toolbar-title>Reset Your Password</v-toolbar-title>
            </v-toolbar>

            <v-form @submit.prevent="reset" v-model="valid">
              <v-card-text>
                <p v-if="message.length">
                  The link you used is invalid or has expired. Please request a new password reset.
                </p>
                <p v-else>
                  You can now set your new password and use that to log in once it has been saved.
                </p>

                <v-text-field
                  label="New Password"
                  v-model="newPassword"
                  type="password"
                  required
                  persistent-hint
                  hint="Select the new password you want to use"
                  :error-messages="message"
                  :disabled="message.length > 0"
                  :color="themes.candidate.light.input"
                />
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  v-if="message.length"
                  :color="themes.candidate.light.secondaryActionButton"
                  to="/password_reset"
                  type="submit"
                >
                  New Reset
                </v-btn>
                <v-btn
                  :color="themes.candidate.light.primaryActionButton"
                  :disabled="!valid"
                  type="submit"
                >
                  Set your password
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>

          <v-card v-else raised class="mt-3">
            <v-toolbar card :color="themes.candidate.light.dialogTitle">
              <v-toolbar-title>Forgotten Password</v-toolbar-title>
            </v-toolbar>

            <v-alert
              type="success"
              class="grey--text text--darken-3 mt-0"
              :value="message"
              transition="scale-transition"
            >
              {{ message }}
            </v-alert>

            <v-form @submit.prevent="request" v-model="valid">
              <v-card-text>
                <p>
                  You can provide your email address and we'll allow you to change your password as
                  long as you have access to your email.
                </p>

                <v-text-field
                  label="Email"
                  v-model="auth.email"
                  type="email"
                  required
                  persistent-hint
                  hint="The email you used when you signed up"
                  :color="themes.candidate.light.input"
                />
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  :color="themes.candidate.light.primaryActionButton"
                  :disabled="!valid"
                  type="submit"
                >
                  Request reset
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
// Mixins
import { managedDocumentAttributes } from '@/mixins/managedDocumentAttributes.js'

// Vue Component
export default {
  mixins: [managedDocumentAttributes],

  created() {
    this.documentAttributes.title = 'Password Reset - Leaply'
  },

  data() {
    return {
      // Model
      auth: { email: '' },
      newPassword: '',
      token: this.$route.params.token,
      role: this.$route.params.role,
      // Validations
      valid: false,
      // Feedback
      message: '',
    }
  },

  methods: {
    request() {
      Vue.$http.post('reset_password', this.auth).then(response => {
        if (response.data.success) {
          this.message =
            'If an account with that address exists it will receive a reset link shortly.'
        }
      })
    },
    reset() {
      if (this.token && this.role) {
        Vue.$http
          .post(`${this.role}s/reset_password`, {
            password: this.newPassword,
            token: this.token,
          })
          .then(
            ({ data }) => {
              this.$store.dispatch('snackbarSuccess', 'Your password has been updated')
              this.$store
                .dispatch('auth/login', { auth: { email: data.email, password: this.newPassword } })
                .then(
                  () => this.$router.push('/'),
                  () => this.$store.dispatch('snackbarError', 'Login Failed')
                )
            },
            () => {
              this.message = 'Invalid or expired reset, request new password reset'
              this.$store.dispatch('snackbarError', 'Invalid or Expired')
            }
          )
      }
    },
  },
}
</script>
